"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var Toast_component_exports = {};
__export(Toast_component_exports, {
  Toast: () => Toast,
  ToastProvider: () => ToastProvider
});
module.exports = __toCommonJS(Toast_component_exports);
var import_jsx_runtime = require("react/jsx-runtime");
var import_react = require("react");
var import_toast = require("@react-stately/toast");
var import_toast2 = require("@react-aria/toast");
var import_ToastContext = require("./ToastContext.component");
var import_ToastRegion = require("./ToastRegion.component");
var import_Button = require("../Button/Button.component");
var import_Cross = __toESM(require("@greatmindsorg/gmui-icons-lib/dist/Cross"));
var import_CrossCircle = __toESM(require("@greatmindsorg/gmui-icons-lib/dist/CrossCircle"));
var import_CheckCircle = __toESM(require("@greatmindsorg/gmui-icons-lib/dist/CheckCircle"));
var import_TriangleWarning = __toESM(require("@greatmindsorg/gmui-icons-lib/dist/TriangleWarning"));
var import_Info = __toESM(require("@greatmindsorg/gmui-icons-lib/dist/Info"));
var import_clsx = __toESM(require("clsx"));
const toastWrap = "m-m rounded-m";
const baseTextStyles = "flex grow font-style-body m-0";
function ToastProvider(_a) {
  var _b = _a, { children } = _b, otherProps = __objRest(_b, ["children"]);
  let state = (0, import_toast.useToastState)(otherProps);
  return /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_ToastContext.ToastContext.Provider, { value: state, children: [
    children(state),
    /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_ToastRegion.ToastRegion, {})
  ] });
}
const Toast = (_c) => {
  var props = __objRest(_c, []);
  let state = (0, import_react.useContext)(import_ToastContext.ToastContext);
  let ref = (0, import_react.useRef)(null);
  let { toastProps, contentProps, titleProps, closeButtonProps } = (0, import_toast2.useToast)(props, state, ref);
  const toastStatus = props.toast.toastStatus || "success";
  const link = props.toast.link;
  const ariaLive = props.toast.ariaLive || "polite";
  const zIndexProp = props.toast.zIndex && { zIndex: props.toast.zIndex };
  const toastRegionWrapper = "gmui-toast-region-wrapper fixed bottom-0 left-0 w-screen pl-3 pr-3 flex justify-center box-border";
  const toastEl = (0, import_clsx.default)([
    "gmui-toast w-[100%] max-w-[720px] md:w-[720px] flex p-m bg-white border-2 border-solid rounded-m box-border",
    "shadow-high",
    {
      "border-[var(--color-border-support-success)]": toastStatus === "success",
      "border-[var(--color-border-support-warning)]": toastStatus === "warning",
      "border-[var(--color-border-support-error)]": toastStatus === "error",
      "border-[var(--color-border-support-info)]": toastStatus === "informative"
    }
  ]);
  const linkWrap = (0, import_clsx.default)([
    baseTextStyles,
    "gmui-toast-link-text ml-4 mr-4 justify-start md:justify-end md:w-[30%]"
  ]);
  const leftIcon = {
    success: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_CheckCircle.default, { iconSize: "m", title: `Alert Type: ${toastStatus}` }),
    warning: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_TriangleWarning.default, { iconSize: "m", title: `Alert Type: ${toastStatus}` }),
    error: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_CrossCircle.default, { iconSize: "m", title: `Alert Type: ${toastStatus}` }),
    informative: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_Info.default, { iconSize: "m", title: `Alert Type: ${toastStatus}` })
  };
  const divRef = (0, import_react.useRef)(null);
  return /* @__PURE__ */ (0, import_jsx_runtime.jsx)("div", { className: toastRegionWrapper, style: zIndexProp, children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)("div", __spreadProps(__spreadValues({}, toastProps), { ref, className: toastWrap, children: /* @__PURE__ */ (0, import_jsx_runtime.jsxs)("div", __spreadProps(__spreadValues({ className: toastEl, ref: divRef }, contentProps), { "aria-live": ariaLive, children: [
    /* @__PURE__ */ (0, import_jsx_runtime.jsx)(
      "div",
      {
        className: (0, import_clsx.default)([
          "gmui-toast-status-icon flex items-start pr-4 md:items-center",
          `gmui-toast-icon-color-${toastStatus}`
        ]),
        children: leftIcon[props.toast.toastStatus]
      }
    ),
    /* @__PURE__ */ (0, import_jsx_runtime.jsxs)("div", { className: "grow gap-4 sm:flex sm:flex-row", children: [
      /* @__PURE__ */ (0, import_jsx_runtime.jsx)("div", { className: "flex md:items-center", children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)("p", __spreadProps(__spreadValues({ className: baseTextStyles }, titleProps), { children: props.toast.content })) }),
      /* @__PURE__ */ (0, import_jsx_runtime.jsx)("div", { className: linkWrap, children: link })
    ] }),
    /* @__PURE__ */ (0, import_jsx_runtime.jsx)("div", { children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(
      import_Button.Button,
      __spreadProps(__spreadValues({
        variant: "tertiary",
        className: "toastCloseButton relative top-[-10px] md:top-0"
      }, closeButtonProps), {
        children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_Button.Button.Icon, { className: "h-[auto] w-[16px]", children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_Cross.default, { iconSize: "inherit", title: `Close Alert` }) })
      })
    ) })
  ] })) })) });
};
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  Toast,
  ToastProvider
});
//# sourceMappingURL=Toast.component.js.map